import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Constants } from '../../core/config/Constants';
import { ExhibitorsService } from '../../core/services/exhibitors.service';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { ExtraService } from '../../core/services/extra.service';
import * as firebase from 'firebase';
import { ActivatedRoute, Router } from '@angular/router';
import { Exhibitor } from '../../core/models/exhibitor';
import { MultiUtility } from '../../shared/multi-utility';
import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { Category } from '../../core/models/category';

@Component({
	selector: 'app-exhibitor-add-new',
	templateUrl: './exhibitor-add-new.component.html',
	styleUrls: ['./exhibitor-add-new.component.css']
})
export class ExhibitorAddNewComponent extends MultiUtility implements OnInit {

	@ViewChild('dropDown', { read: ViewContainerRef }) dropDown: ViewContainerRef;

	buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
	eventId: string;

	pageTitle: string = 'Create Exhibitor';
	editTitle: string = 'Edit Exhibitor';
	pageAlias: string = 'exhibitors';

	exhibitorId: string;
	exhibitorCount = 0;
	exhibitor = new Exhibitor();
	exhibitorTypeText: string;

	categoryOrderList: Array<any> = [];

	bannerImageFile: File = null;
	iconImageFile: File = null;

	progress: { percentage: number } = { percentage: 0 };

	uploadImgTypeBanner = Constants.IMAGE_UPLOAD_TYPE_BANNER;
	uploadImgTypeIcon = Constants.IMAGE_UPLOAD_TYPE_ICON;

	log(event: boolean) {
		console.log(`Accordion has been ${event ? 'opened' : 'closed'}`);
	}

	constructor(private router: Router,
		newPageService: NewPageService,
		_cfr: ComponentFactoryResolver,
		private exhibitorService: ExhibitorsService,
		extraService: ExtraService,
		multiUtilityService: MultiUtilityService,
		private route: ActivatedRoute) {

		super(multiUtilityService, extraService, newPageService, _cfr);
	}

	ngOnInit() {
		super.initComponentThings();
		this.initExhibitorInfo();
	}

	private initThings() {
		this.aboutListUp(this.exhibitor, this.dropDown);
		this.aboutListDown(this.exhibitor, this.dropDown);
		this.aboutListRemove(this.exhibitor);
	}

	private initExhibitorInfo() {
		this.route.queryParams.subscribe(params => {
			this.eventId = params['eventId'];
			this.getExhibitorCategory(params['eventId']);

			if (params['eventId']) {
				if (params['exhibitorId']) {
					this.exhibitorId = params['exhibitorId'];
					this.getExhibitorById(params['eventId'], params['exhibitorId']);
				} else {
					this.getExhibitorCount(params['eventId']);
				}
			}
			this.extraService.setCurrentEventId(params['eventId']);
		});
	}

	getExhibitorCategory(id) {
		this.categoryOrderList = [];
		this.exhibitorService.getExhibitorType(id).subscribe(event => {
			if (event) {
				for (let key in event) {
					let exhibitorOrderType = new Category(); // Should I make it some generic method, It is used by Sponsors also
					exhibitorOrderType.$key = key;
					exhibitorOrderType.position = event[key].position;
					exhibitorOrderType.text = event[key].text;
					this.categoryOrderList[event[key].position] = exhibitorOrderType;
				}
			}
		});
	}

	getExhibitorById(eventId: string, exhibitorId: string) {
		this.exhibitorService.getSingleExhibitor(eventId, exhibitorId).subscribe(event => {
			if (event) {
				// this.exhibitor = event;
				// console.log("huuh  " + this.exhibitor);

				this.exhibitor = new Exhibitor();
				this.exhibitor.name = event.name;
				this.exhibitor.website = event.website === undefined ? null : event.website;
				this.exhibitor.hasDetailsPage = event.hasDetailsPage === undefined ? null : event.hasDetailsPage;
				this.exhibitor.type = event.type === undefined ? null : event.type;
				this.exhibitor.position = event.position;
				this.exhibitor.bannerCMId = event.bannerCMId === undefined ? null : event.bannerCMId;
				this.exhibitor.bannerUrl = event.bannerCMId === undefined ? null : event.bannerUrl;
				this.exhibitor.aboutList = event.aboutList === undefined ? [] : event.aboutList;



				if (this.exhibitor.aboutList) {
					this.exhibitor.aboutList.forEach(element => {
						this.addComponent(element, this.dropDown, this.eventId);
					});
				} else {
					this.exhibitor.aboutList = [];
				}
				this.initThings();
				this.getCategoryItemName(eventId, Constants.CATEGORY_EXHIBITORS, this.exhibitor.type).subscribe(event => {
					if (event) {
						console.log('getCategoryItemName	:	' + event);
						this.exhibitorTypeText = event;
					}
				});
			}
		});
	}

	getExhibitorCount(eventId: string) {
		let x = this.exhibitorService.getExhibitorsList(eventId);
		x.snapshotChanges().subscribe(list => {
			this.exhibitorCount = list.length;
		});
	}

	checkType(key, text) {
		if (key) {
			this.exhibitor.type = key;
			this.exhibitorTypeText = text
		}
	}

	addAboutElement() {
		this.showDropDown(this.dropDown, this.exhibitor, this.eventId);
	}


	uploadImage(event, source) {

		switch (source) {
			case this.uploadImgTypeBanner:
				console.log('Source Logo :: ', source);
				this.bannerImageFile = event.files[0];
				this.uploadImageToStorage(this.bannerImageFile, firebase, this.exhibitor, this.eventId, Constants.CONTENT_M_TYPE_EXHIBITORS, this.uploadImgTypeBanner);
				break;

			case this.uploadImgTypeIcon:
				console.log('Source Icon :: ', source);
				this.iconImageFile = event.files[0];
				this.uploadImageToStorage(this.iconImageFile, firebase, this.exhibitor, this.eventId, Constants.CONTENT_M_TYPE_EXHIBITORS, this.uploadImgTypeIcon);
				break;
		}
	}

	// deleteLogoImage() {
	//   this.logoImageFile = null;
	// }

	// deleteIconImage() {
	//   this.iconImageFile = null;
	// }

	submit() {
		this.confirmMessage = null;
		this.isError = false;
		this.errorMessage = [];

		if (this.validate(this.exhibitor)) {
			if (!this.exhibitorId) {
				this.disableButton = false;
				this.exhibitor.position = this.exhibitorCount;
				let exhibitorKey = this.exhibitorService.addExhibitorDetails(this.exhibitor, this.eventId);
				if (exhibitorKey) {
					this.confirmMessage = 'Added Successfully';
				}

			} else {
				this.disableButton = false;

				this.exhibitorService.updateExhibitorDetails(this.exhibitor, this.eventId, this.exhibitorId).then(res => {
					this.confirmMessage = 'Update Successfully';
				}).catch(error => {
					this.disableButton = true;
					this.errorMessage = error.message;
				});
			}
			setTimeout(function () {
				this.confirmMessage = null;
				this.disableButton = true;
				this.router.navigate([Constants.EXHIBITOR_FORM, this.eventId]);
			}.bind(this), 2000);

		} else {
			this.isError = true;
		}
	}

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/exhibitor-add-new/exhibitor-add-new.component.ts